var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWelcomeTop = function SvgWelcomeTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#CD1C45",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.573,
    cy: 55.357,
    r: 12.815
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.723 66.274.474-21.596s6.074 5.294 11.392 5.22c5.147-.07 12.103-5.22 12.103-5.22v21.596s-6.798-4.665-12.103-4.747c-5.47-.084-11.866 4.747-11.866 4.747"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.077,
    cy: 55.357,
    r: 12.815
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 55.358,
    cy: 22.736,
    r: 12.815,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.638,
    cy: 22.736,
    r: 12.815,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.638,
    cy: 87.978,
    r: 12.815,
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.358,
    cy: 87.978,
    r: 12.815,
    opacity: 0.3
  }))));
};
export default SvgWelcomeTop;